<template>
  <div>
    <div class="modal fade" id="addQuoteRequestModal" ref="modalEle" tabindex="-1" role="dialog"
      aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" :class="productViewMode === 'details' ? 'modal-xl' : 'modal-full-width'"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Utwórz zamówienie</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div v-if="form && isReady" class="container-fluid">
              <div class="row">
                <div class="col-md-5">
                  <label for="dueDate">Ostateczny termin dostawy:</label>
                  <div class="mb-4" style="max-width: 300px;">
                    <ejs-datepicker id="projectFileProgressId" placeholder="Wybierz zakres dat" :value="form.dueDate"
                      :format="dueDateFormat" :weekNumber="true" @change="changeDeliveryDate"></ejs-datepicker>
                  </div>
                </div>

                <div class="col-md-7">
                  <label for="emails">
                    Wyślij zamówienie na poniższe maile:
                    <a class="btn btn-xs btn-primary" :href="route('customers.create')" target="_blank">
                      Utwórz klienta
                    </a>
                    <button type="button" class="btn btn-xs btn-outline-primary ms-2" @click="getSuppliersEmails()">
                      Odśwież listę
                    </button>
                  </label>

                  <div v-if="hasError(`emails`)" class="text-danger small">
                    {{ getErrorMessage(`emails`) }}
                  </div>

                  <table class="table">
                    <tbody>
                      <tr v-for="(email, key) in form.emails" :key="'supplier-' + key">
                        <td>
                          <TagSelect :endpoint="route('customers.get-customers-with-contacts')" label="Mail Dostawcy"
                            label-key="label" value-key="value" name="emailsTo[]" v-model="form.emails[key].to"
                            @selected="setEmailCustomer(key, $event)" :max="1" />
                        </td>
                      </tr>

                      <tr v-for="(email, key) in form.emails" :key="'dw-' + key">
                        <td>
                          <TagSelect :endpoint="route('customers.get-customers-with-contacts')" label="Maile DW"
                            label-key="label" value-key="value" name="emailsDw[]" v-model="form.emails[key].dw"
                            multiple />
                          <input type="text" class="form-control form-control-sm mt-1"
                            placeholder="Wpisz e-mail i Enter" @keydown.enter.prevent="addManualDwEmail(key, $event)" />
                          <div class="mt-1">
                            <span v-for="(mail, i) in safeDw(form.emails[key].dw)" :key="i"
                              class="badge bg-secondary me-1" style="cursor:pointer" @click="removeDwEmail(key, i)">
                              {{ mail }} ✕
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="!hasSupplierEmail" class="alert alert-warning">
                Wybierz najpierw dostawcę.
              </div>

              <div v-else>
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <Vueform>
                      <TextElement name="comments" @change="changeComment($event)" autocomplete="off"
                        label="Komentarz do zamówienia"
                        placeholder="Komentarz będzie widoczny dla dostawcy po wysłaniu" />
                    </Vueform>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-md-4">
                    <label>Forma płatności</label>
                    <select class="form-select form-select-sm" v-model="form.payment_id">
                      <option v-for="method in paymentMethods" :key="method.id" :value="method.id">
                        {{ method.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label>Waluta globalna</label>
                    <select class="form-select form-select-sm" v-model.number="globalCurrency"
                      @change="applyGlobalCurrency">
                      <option v-for="currency in currencys" :key="currency.id" :value="currency.id">
                        {{ currency.name }}
                      </option>
                    </select>
                  </div>
				  
                  <div class="col-md-4">
                    <label>Negocjacje:</label>
                    <select class="form-select form-select-sm" v-model="form.negotiation">
                      <option v-for="negotiation in negotiations" :key="negotiation.id" :value="negotiation.id">{{
                        negotiation.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label>Rabat globalny (%)</label>
                    <input type="number" class="form-control form-control-sm" v-model.number="globalRabate" min="0"
                      step="0.1" @input="applyGlobalRabate">
                  </div>
					<div class="col-md-4">
					  <label>Ustalona kwota netto</label>
					  <input
						type="number"
						class="form-control form-control-sm"
						v-model.number="fixedNettoAmount"
						min="0"
						step="0.01"
						@input="applyFixedNettoAmount"
					  >
					</div>

                  <div class="col-md-4">
                    <label>Adres dostawy</label>
                    <select class="form-select form-select-sm" v-model="form.order_where">
                      <option v-for="where in order_where_list" :key="where.id" :value="where.id">
                        {{ where.nazwa }} - {{ where.adres_1 }}
					  </option>
					  <option :value="3"> Inny </option>
                    </select>
					<div v-if="Number(form.order_where) === 3" class="mt-2">
  					  <input type="text" class="form-control form-control-sm" v-model="form.order_where_manual" placeholder="Wpisz adres dostawy" autocomplete="off" >
					</div>					
                  </div>
                </div>
                <div class="d-flex justify-content-end align-items-center mb-3">
                  <div class="btn-group" role="group" aria-label="Widok produktów">
                    <button type="button" class="btn btn-sm"
                      :class="productViewMode === 'details' ? 'btn-primary' : 'btn-outline-primary'"
                      @click="productViewMode = 'details'">
                      <i class="bi bi-layout-text-window-reverse me-1"></i>
                      Widok szczegółowy
                    </button>

                    <button type="button" class="btn btn-sm"
                      :class="productViewMode === 'table' ? 'btn-primary' : 'btn-outline-primary'"
                      @click="productViewMode = 'table'">
                      <i class="bi bi-table me-1"></i>
                      Widok tabelaryczny
                    </button>
                  </div>
                </div>
                <template v-if="productViewMode === 'details'">
                  <template v-for="group in groupedArticles" :key="group.key">
                    <template v-if="group.indexes.length === 1">
                      <template v-for="idx in group.indexes" :key="idx">
                        <table class="table order-list-table">
                          <tbody>
                            <tr>
                              <td colspan="2" class="position-relative">
                                <span>#{{ idx + 1 }}</span>
                                <button type="button"
                                  class="btn btn-sm btn-outline-danger position-absolute end-0 top-50 translate-middle-y me-1"
                                  title="Usuń artykuł" @click="removeArticle(idx)">
                                  <i class="bi bi-trash"></i>
                                </button>
                              </td>
                            </tr>

                            <tr>
                              <td class="widthFirstTd">Do zapytania ofertowego</td>
                              <td>{{ form.articles[idx].quote_request?.request_number ||
                                '' }}</td>
                            </tr>

                            <tr>
                              <td class="widthFirstTd">Nr katalogowy</td>
                              <td>{{ form.articles[idx].catalog_number }}</td>
                            </tr>

                            <tr>
                              <td class="widthFirstTd">Model</td>
                              <td>{{ form.articles[idx].model }}</td>
                            </tr>

                            <tr>
                              <td class="widthFirstTd">
                                Ilość zamawiana
                                <i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top"
                                  title="Całkowita ilość. Powinna być pomniejszona o zarezerwowane sztuki."></i>
                              </td>
                              <td class="d-flex align-items-center">
                                <div v-if="hasError(`articles.${idx}.quantity_required`)" class="text-danger small">
                                  {{
                                    getErrorMessage(`articles.${idx}.quantity_required`)
                                  }}
                                </div>
                                <input class="form-control form-control-sm" type="number" step="0.1" min="0"
                                  v-model.number="form.articles[idx].quantity_required" required>
                                <div class="ms-2 text-nowrap">{{ form.articles[idx].unit
                                }}</div>
                              </td>
                            </tr>
                            <tr v-if="
                              reservations[
                                `${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`
                              ]?.currentlyReserved > 0
                            ">
                              <td class="widthFirstTd">
                                Zarezerwowane
                                <i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top"
                                  title="Zarezerwowana ilość pomniejszona o sztuki, które już trafiły na magazyn projektowy"></i>
                              </td>

                              <td>
                                <span :class="reservations[
                                  `${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`
                                ].reservationStatus === 'zatwierdzone'
                                  ? 'reservation-approved'
                                  : 'reservation-notapproved'
                                  ">
                                  {{
                                    reservations[
                                      `${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`
                                    ].currentlyReserved
                                  }}
                                  -
                                  {{
                                    reservations[
                                      `${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`
                                    ].reservationStatus
                                  }}
                                </span>
                              </td>
                            </tr>

                            <tr>
                              <td class="widthFirstTd">Ostateczny termin dostawy</td>
                              <td>
                                <div v-if="hasError(`articles.${idx}.delivery_date_deadline`)"
                                  class="text-danger small">
                                  {{
                                    getErrorMessage(`articles.${idx}.delivery_date_deadline`)
                                  }}
                                </div>
                                <input class="form-control form-control-sm" type="date"
                                  v-model="form.articles[idx].delivery_date_deadline" required>
                              </td>
                            </tr>

                            <tr>
                              <td class="widthFirstTd">Producent</td>
                              <td>
                                <template v-if="form.articles[idx].producer_short_name">
                                  <span class="font-weight-bolder">
                                    {{ form.articles[idx].producer_short_name }}
                                  </span>
                                </template>
                                <template v-else>
                                  <i>Brak domyślnego producenta</i>
                                </template>
                              </td>
                            </tr>

                            <tr>
                              <td class="widthFirstTd">Cena netto</td>
                              <td>
                                <input type="number" class="form-control form-control-sm" min="0" step="0.01"
                                  v-model.number="form.articles[idx].price_netto">
                              </td>
                            </tr>
                            <tr>
                              <td class="widthFirstTd">Cena brutto</td>
                              <td>
<input
  type="number"
  class="form-control form-control-sm mt-1"
  min="0"
  step="0.01"
  :value="calculateGrossValue(form.articles[idx])"
  @change="updatePriceFromGross(form.articles[idx], $event.target.value)"
  placeholder="Cena brutto"
>
                              </td>
                            </tr>
                            <tr>
                              <td class="widthFirstTd">Rabat (%)</td>
                              <td class="d-flex align-items-center">
                                <input type="number" class="form-control form-control-sm"
                                  v-model.number="form.articles[idx].rabate">
                                <div class="ms-2 text-nowrap">
                                  Kwota rabatu:
                                  {{
                                    (
                                      (form.articles[idx].price_netto *
                                        form.articles[idx].quantity_required) *
                                      (form.articles[idx].rabate / 100)
                                    ).toLocaleString('pl-PL', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                  })
                                  }}


                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td class="widthFirstTd">VAT</td>
                              <td>
                                <input type="number" class="form-control form-control-sm"
                                  v-model.number="form.articles[idx].vat">
                              </td>
                            </tr>

                            <tr>
                              <td class="widthFirstTd">Waluta</td>
                              <td>
                                <select class="form-select form-select-sm" v-model.number="form.articles[idx].currency">
                                  <option v-for="currency in currencys" :key="currency.id" :value="currency.id">
                                    {{ currency.name }}
                                  </option>
                                </select>
                              </td>
                            </tr>

                            <tr>
                              <td class="widthFirstTd">Wartość netto</td>
                              <td>
                                <input type="number" class="form-control form-control-sm" min="0" step="0.01"
                                  :value="calculateNettoValue(form.articles[idx])" @change="updatePriceFromNetto(
                                    form.articles[idx],
                                    $event.target.value,
                                    form.articles[idx].quantity_required
                                  )">
                              </td>
                            </tr>

                            <tr>
                              <td class="widthFirstTd">Uwagi do pozycji</td>
                              <td>
                                <input type="text" class="form-control form-control-sm"
                                  v-model="form.articles[idx].comments">
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </template>
                    </template>

                    <template v-else>
                      <table class="table order-list-table">
                        <tbody>
                          <tr>
                            <td colspan="2">
                              <div class="d-flex align-items-center justify-content-between gap-3">
                                <div class="d-flex align-items-center gap-2 flex-grow-1 min-width-0">
                                  <span class="badge bg-info">
                                    Połączone zapotrzebowania: {{
                                      group.indexes.length }}
                                  </span>
                                  <span class="text-muted small text-truncate">
                                    #{{group.indexes.map(i => i + 1).join(' · #')
                                    }}
                                  </span>
                                </div>
                                <div class="d-flex align-items-center gap-1 flex-shrink-0">
                                  <button type="button" class="btn btn-sm btn-outline-info"
                                    :title="isArticleGroupExpanded(group.key) ? 'Zwiń pozycje' : 'Rozwiń pozycje'"
                                    @click="toggleArticleGroup(group.key)">
                                    <i
                                      :class="isArticleGroupExpanded(group.key) ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                                  </button>
                                  <button type="button" class="btn btn-sm btn-outline-danger"
                                    title="Usuń wszystkie pozycje" @click="removeArticleGroup(group)"><i
                                      class="bi bi-trash"></i></button>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td class="widthFirstTd">Do zapytania ofertowego</td>
                            <td>{{ group.firstArticle.quote_request?.request_number || '' }}
                            </td>
                          </tr>

                          <tr>
                            <td class="widthFirstTd">Nr katalogowy</td>
                            <td>{{ group.firstArticle.catalog_number }}</td>
                          </tr>

                          <tr>
                            <td class="widthFirstTd">Model</td>
                            <td>{{ group.firstArticle.model }}</td>
                          </tr>

                          <tr>
                            <td class="widthFirstTd">
                              Ilość zamawiana
                              <i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top"
                                title="Suma ilości wszystkich identycznych pozycji."></i>
                            </td>
                            <td class="d-flex align-items-center">
                              <input type="number" class="form-control form-control-sm" :value="group.totalQuantity"
                                readonly>
                              <div class="ms-2 text-nowrap">{{ group.firstArticle.unit }}
                              </div>
                            </td>
                          </tr>
                          <tr v-if="
                            reservations[
                              `${form.articles[group.indexes[0]].article_id}-${form.articles[group.indexes[0]].required_project_item_id}`
                            ]?.currentlyReserved > 0
                          ">
                            <td class="widthFirstTd">
                              Zarezerwowane
                              <i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top"
                                title="Zarezerwowana ilość pomniejszona o sztuki, które już trafiły na magazyn projektowy"></i>
                            </td>

                            <td>
                              <span :class="reservations[
                                `${form.articles[group.indexes[0]].article_id}-${form.articles[group.indexes[0]].required_project_item_id}`
                              ].reservationStatus === 'zatwierdzone'
                                ? 'reservation-approved'
                                : 'reservation-notapproved'
                                ">
                                {{
                                  reservations[
                                    `${form.articles[group.indexes[0]].article_id}-${form.articles[group.indexes[0]].required_project_item_id}`
                                  ].currentlyReserved
                                }}
                                -
                                {{
                                  reservations[
                                    `${form.articles[group.indexes[0]].article_id}-${form.articles[group.indexes[0]].required_project_item_id}`
                                  ].reservationStatus
                                }}
                              </span>
                            </td>
                          </tr>

                          <tr>
                            <td class="widthFirstTd">Ostateczny termin dostawy</td>
                            <td>
                              <input type="date" class="form-control form-control-sm"
                                :value="group.firstArticle.delivery_date_deadline"
                                @change="updateGroupField(group, 'delivery_date_deadline', $event.target.value)">
                            </td>
                          </tr>

                          <tr>
                            <td class="widthFirstTd">Producent</td>
                            <td>
                              <template v-if="group.firstArticle.producer_short_name">
                                <span class="font-weight-bolder">
                                  {{ group.firstArticle.producer_short_name }}
                                </span>
                              </template>
                              <template v-else>
                                <i>Brak domyślnego producenta</i>
                              </template>
                            </td>
                          </tr>

                          <tr>
                            <td class="widthFirstTd">Cena netto</td>
                            <td>
                              <input type="number" class="form-control form-control-sm" min="0" step="0.01"
                                :value="group.firstArticle.price_netto"
                                @input="updateGroupField(group, 'price_netto', Number($event.target.value))">
                            </td>
                          </tr>
                          <tr>
                            <td class="widthFirstTd">Cena brutto</td>
                            <td>
<input
  type="number"
  class="form-control form-control-sm mt-1"
  min="0"
  step="0.01"
  :value="calculateGrossValue(group.firstArticle)"
  @change="updateGroupPriceFromGross(group, $event.target.value)"
  placeholder="Cena brutto"
>
                            </td>
                          </tr>
                          <tr>
                            <td class="widthFirstTd">Rabat (%)</td>
                            <td class="d-flex align-items-center">
                              <input type="number" class="form-control form-control-sm"
                                :value="group.firstArticle.rabate"
                                @input="updateGroupField(group, 'rabate', Number($event.target.value))">
                              <div class="ms-2 text-nowrap">
                                Kwota rabatu:
                                  {{
                                    (
                                      (group.firstArticle.price_netto *
                                       group.totalQuantity) *
                                      (group.firstArticle.rabate / 100)
                                    ).toLocaleString('pl-PL', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                  })
                                  }}								
								
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td class="widthFirstTd">VAT</td>
                            <td>
                              <input type="number" class="form-control form-control-sm" :value="group.firstArticle.vat"
                                @input="updateGroupField(group, 'vat', Number($event.target.value))">
                            </td>
                          </tr>

                          <tr>
                            <td class="widthFirstTd">Waluta</td>
                            <td>
                              <select class="form-select form-select-sm" :value="group.firstArticle.currency"
                                @change="updateGroupField(group, 'currency', Number($event.target.value))">
                                <option v-for="currency in currencys" :key="currency.id" :value="currency.id">
                                  {{ currency.name }}
                                </option>
                              </select>
                            </td>
                          </tr>

                          <tr>
                            <td class="widthFirstTd">Wartość netto</td>
                            <td>
                              <input type="number" class="form-control form-control-sm" min="0" step="0.01"
                                :value="calculateNettoValue(group.firstArticle, group.totalQuantity)" @change="updatePriceFromNetto(
                                  group.firstArticle,
                                  $event.target.value,
                                  group.totalQuantity
                                )">
                            </td>
                          </tr>

                          <tr>
                            <td class="widthFirstTd">Uwagi do pozycji</td>
                            <td>
                              <div class="d-flex flex-column gap-1">
                                <div v-for="idx in group.indexes" :key="'comment-' + idx"
                                  class="d-flex align-items-center">
                                  <span class="text-muted me-2">#{{ idx + 1 }}</span>
                                  <input type="text" class="form-control form-control-sm"
                                    :value="form.articles[idx].comments" readonly>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div v-if="isArticleGroupExpanded(group.key)" class="border-start border-3 ps-3 mb-3">
                        <template v-for="idx in group.indexes" :key="'expanded-' + idx">
                          <table class="table order-list-table">
                            <tbody>
                              <tr>
                                <td colspan="2" class="position-relative">
                                  <span>#{{ idx + 1 }}</span>
                                  <button type="button"
                                    class="btn btn-sm btn-outline-danger position-absolute end-0 top-50 translate-middle-y me-1"
                                    title="Usuń artykuł" @click="removeArticle(idx)">
                                    <i class="bi bi-trash"></i>
                                  </button>
                                </td>
                              </tr>
                              <tr>
                                <td class="widthFirstTd">Do zapytania ofertowego</td>
                                <td>{{ form.articles[idx].quote_request?.request_number
                                  || '' }}</td>
                              </tr>
                              <tr>
                                <td class="widthFirstTd">Nr katalogowy</td>
                                <td>{{ form.articles[idx].catalog_number }}</td>
                              </tr>
                              <tr>
                                <td class="widthFirstTd">Model</td>
                                <td>{{ form.articles[idx].model }}</td>
                              </tr>
                              <tr>
                                <td class="widthFirstTd">Ilość zamawiana</td>
                                <td>
                                  <div v-if="hasError(`articles.${idx}.quantity_required`)" class="text-danger small">
                                    {{
                                      getErrorMessage(`articles.${idx}.quantity_required`)
                                    }}
                                  </div>
                                  <input class="form-control form-control-sm" type="number" step="0.1" min="0"
                                    v-model.number="form.articles[idx].quantity_required" required>
                                </td>
                              </tr>
                              <tr v-if="
                                reservations[
                                  `${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`
                                ]?.currentlyReserved > 0
                              ">
                                <td class="widthFirstTd">
                                  Zarezerwowane
                                </td>

                                <td>
                                  <span :class="reservations[
                                    `${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`
                                  ].reservationStatus === 'zatwierdzone'
                                    ? 'reservation-approved'
                                    : 'reservation-notapproved'
                                    ">
                                    {{
                                      reservations[
                                        `${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`
                                      ].currentlyReserved
                                    }}
                                    -
                                    {{
                                      reservations[
                                        `${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`
                                      ].reservationStatus
                                    }}
                                  </span>
                                </td>
                              </tr>

                              <tr>
                                <td class="widthFirstTd">Ostateczny termin dostawy</td>
                                <td>
                                  <input class="form-control form-control-sm" type="date"
                                    v-model="form.articles[idx].delivery_date_deadline" required>
                                </td>
                              </tr>

                              <tr>
                                <td class="widthFirstTd">Producent</td>
                                <td>
                                  <template v-if="form.articles[idx].producer_short_name">
                                    <span class="font-weight-bolder">
                                      {{ form.articles[idx].producer_short_name }}
                                    </span>
                                  </template>
                                  <template v-else>
                                    <i>Brak domyślnego producenta</i>
                                  </template>
                                </td>
                              </tr>

                              <tr>
                                <td class="widthFirstTd">Cena netto</td>
                                <td>
                                  <input type="number" class="form-control form-control-sm" min="0" step="0.01"
                                    v-model.number="form.articles[idx].price_netto">
                                </td>
                              </tr>
                              <tr>
                                <td class="widthFirstTd">Cena brutto</td>
                                <td>
                                  <input type="number" class="form-control form-control-sm" min="0" step="0.01"
                                    v-model.number="form.articles[idx].price_netto">
                                </td>
                              </tr>
                              <tr>
                                <td class="widthFirstTd">Rabat (%)</td>
                                <td>
<input
  type="number"
  class="form-control form-control-sm mt-1"
  min="0"
  step="0.01"
  :value="calculateGrossValue(form.articles[idx])"
  @change="updatePriceFromGross(form.articles[idx], $event.target.value)"
  placeholder="Cena brutto"
>
                                </td>
                              </tr>

                              <tr>
                                <td class="widthFirstTd">VAT</td>
                                <td>
                                  <input type="number" class="form-control form-control-sm"
                                    v-model.number="form.articles[idx].vat">
                                </td>
                              </tr>

                              <tr>
                                <td class="widthFirstTd">Waluta</td>
                                <td>
                                  <select class="form-select form-select-sm"
                                    v-model.number="form.articles[idx].currency">
                                    <option v-for="currency in currencys" :key="currency.id" :value="currency.id">
                                      {{ currency.name }}
                                    </option>
                                  </select>
                                </td>
                              </tr>

                              <tr>
                                <td class="widthFirstTd">Wartość netto</td>
                                <td>
                                  <input type="number" class="form-control form-control-sm" min="0" step="0.01"
                                    :value="calculateNettoValue(form.articles[idx])" @change="updatePriceFromNetto(
                                      form.articles[idx],
                                      $event.target.value,
                                      form.articles[idx].quantity_required
                                    )">
                                </td>
                              </tr>

                              <tr>
                                <td class="widthFirstTd">Uwagi do pozycji</td>
                                <td>
                                  <input type="text" class="form-control form-control-sm"
                                    v-model="form.articles[idx].comments">
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </template>
                      </div>
                    </template>
                  </template>
                </template>
                <template v-else>
                  <div class="table-responsive">
                    <table class="table table-sm table-hover align-middle order-products-table">
                      <thead>
                        <tr>
                          <th style="width: 50px;">#</th>
                          <th>Nr kat.</th>
                          <th>Model</th>
                          <th>Producent</th>
                          <th>Ilość</th>
                          <th>Termin</th>
                          <th>Cena netto</th>
                          <th>Rabat</th>
                          <th>VAT</th>
                          <th>Waluta</th>
                          <th>Wartość netto</th>
                          <th style="width: 90px;">Akcje</th>
                        </tr>
                      </thead>

                      <tbody>
                        <template v-for="group in groupedArticles" :key="'table-' + group.key">

                          <!-- ZWYKŁA POZYCJA -->
                          <template v-if="group.indexes.length === 1">
                            <tr>
                              <td>
                                #{{ group.indexes[0] + 1 }}
                              </td>

                              <td>
                                {{ group.firstArticle.catalog_number }}
                              </td>

                              <td>
                                {{ group.firstArticle.model }}
                              </td>

                              <td>
                                <span v-if="group.firstArticle.producer_short_name">
                                  {{ group.firstArticle.producer_short_name }}
                                </span>
                                <span v-else class="text-muted">
                                  Brak producenta
                                </span>
                              </td>
                              <td>
                                <div>
                                  <!-- Ilość -->
                                  <div class="d-flex align-items-center">
                                    <input type="number" step="0.1" min="0" class="form-control form-control-sm"
                                      style="width: 90px;"
                                      v-model.number="form.articles[group.indexes[0]].quantity_required">

                                    <span class="ms-1 text-nowrap">
                                      {{ group.firstArticle.unit }}
                                    </span>
                                  </div>

                                  <!-- Rezerwacja POD ilością -->
                                  <template v-if="
                                    group.indexes.every(
                                      idx =>
                                        reservations[
                                        `${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`
                                        ]
                                    )
                                  ">
                                    <div v-if="
                                      group.indexes.reduce((sum, idx) => {
                                        const reservation =
                                          reservations[
                                          `${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`
                                          ];

                                        return sum + (reservation?.currentlyReserved || 0);
                                      }, 0) > 0
                                    " class="mt-1">
                                      <small class="text-muted">
                                        Zarezerwowane:
                                      </small>

                                      <span>
                                        {{
                                          group.indexes.reduce((sum, idx) => {
                                            const reservation =
                                              reservations[
                                              `${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`
                                              ];

                                            return sum +
                                              (reservation?.currentlyReserved || 0);
                                          }, 0)
                                        }}
                                      </span>
                                    </div>
                                  </template>
                                </div>
                              </td>

                              <td>
                                <input type="date" class="form-control form-control-sm"
                                  v-model="form.articles[group.indexes[0]].delivery_date_deadline">
                              </td>

<td>
  <input
    type="number"
    min="0"
    step="0.01"
    class="form-control form-control-sm"
    style="width: 110px;"
    v-model.number="form.articles[group.indexes[0]].price_netto"
  >

  <input
    type="number"
    min="0"
    step="0.01"
    class="form-control form-control-sm mt-1"
    style="width: 110px;"
    :value="calculateGrossValue(form.articles[group.indexes[0]])"
    @change="updatePriceFromGross(form.articles[group.indexes[0]], $event.target.value)"
    placeholder="Brutto"
  >
</td>

                              <td>
                                <input type="number" class="form-control form-control-sm" style="width: 80px;"
                                  v-model.number="form.articles[group.indexes[0]].rabate">
                              </td>

                              <td>
                                <input type="number" class="form-control form-control-sm" style="width: 75px;"
                                  v-model.number="form.articles[group.indexes[0]].vat">
                              </td>

                              <td>
                                <select class="form-select form-select-sm"
                                  v-model.number="form.articles[group.indexes[0]].currency">
                                  <option v-for="currency in currencys" :key="currency.id" :value="currency.id">
                                    {{ currency.name }}
                                  </option>
                                </select>
                              </td>

                              <td>
                                <input type="number" min="0" step="0.01" class="form-control form-control-sm"
                                  style="width: 120px;" :value="calculateNettoValue(group.firstArticle)" @change="updatePriceFromNetto(
                                    group.firstArticle,
                                    $event.target.value,
                                    group.firstArticle.quantity_required
                                  )">
                              </td>

                              <td>
                                <button type="button" class="btn btn-sm btn-outline-danger" title="Usuń artykuł"
                                  @click="removeArticle(group.indexes[0])">
                                  <i class="bi bi-trash"></i>
                                </button>
                              </td>
                            </tr>

                            <!-- KOMENTARZ -->
                            <tr>
                              <td></td>
                              <td colspan="11">
                                <div class="d-flex align-items-center gap-2">
                                  <span class="text-muted small">
                                    Uwagi:
                                  </span>

                                  <input type="text" class="form-control form-control-sm"
                                    v-model="form.articles[group.indexes[0]].comments">
                                </div>
                              </td>
                            </tr>
                          </template>


                          <!-- GRUPA POZYCJI -->
                          <template v-else>
                            <tr class="table-light">
                              <td>
                                <div class="d-flex align-items-center gap-1">
                                  <button type="button" class="btn btn-sm btn-outline-info"
                                    :title="isArticleGroupExpanded(group.key) ? 'Zwiń pozycje' : 'Rozwiń pozycje'"
                                    @click="toggleArticleGroup(group.key)">
                                    <i
                                      :class="isArticleGroupExpanded(group.key) ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                                  </button>
                                  <span>
                                    #{{group.indexes.map(i => i + 1).join(', #')}}
                                  </span>
                                </div>
                              </td>
                              <td>
                                {{ group.firstArticle.catalog_number }}
                              </td>
                              <td>
                                {{ group.firstArticle.model }}
                              </td>
                              <td>
                                <span v-if="group.firstArticle.producer_short_name">
                                  {{ group.firstArticle.producer_short_name }}
                                </span>
                                <span v-else class="text-muted">
                                  Brak producenta
                                </span>
                              </td>

                              <td>
                                <div>
                                  <div>
                                    {{ group.totalQuantity }} {{
                                      group.firstArticle.unit }}
                                  </div>

                                  <div v-if="
                                    reservations[
                                      `${form.articles[group.indexes[0]].article_id}-${form.articles[group.indexes[0]].required_project_item_id}`
                                    ]?.currentlyReserved > 0
                                  " class="mt-1">
                                    <small class="text-muted">
                                      Zarezerwowane:
                                    </small>

                                    <span :class="reservations[
                                      `${form.articles[group.indexes[0]].article_id}-${form.articles[group.indexes[0]].required_project_item_id}`
                                    ].reservationStatus === 'zatwierdzone'
                                      ? 'reservation-approved'
                                      : 'reservation-notapproved'
                                      ">
                                      {{
                                        reservations[
                                          `${form.articles[group.indexes[0]].article_id}-${form.articles[group.indexes[0]].required_project_item_id}`
                                        ].currentlyReserved
                                      }}
                                      -
                                      {{
                                        reservations[
                                          `${form.articles[group.indexes[0]].article_id}-${form.articles[group.indexes[0]].required_project_item_id}`
                                        ].reservationStatus
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </td>

                              <td>
                                {{ group.firstArticle.delivery_date_deadline }}
                              </td>

                              <td>
                                {{ group.firstArticle.price_netto }}
                              </td>

                              <td>
                                {{ group.firstArticle.rabate }}
                              </td>

                              <td>
                                {{ group.firstArticle.vat }}
                              </td>

                              <td>
                                {{ group.firstArticle.currency }}
                              </td>

                              <td class="text-nowrap">
                                {{
                                  calculateNettoValue(
                                    group.firstArticle,
                                    group.totalQuantity
                                  ).toLocaleString('pl-PL', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                  })
                                }}
                              </td>
                              <td>
                              </td>
                            </tr>

                            <!-- UWAGI GRUPY -->
                            <tr class="table-light">
                              <td></td>
                              <td colspan="11">
                                <div class="d-flex flex-column gap-1">
                                  <div v-for="idx in group.indexes" :key="'table-comment-' + idx"
                                    class="d-flex align-items-center gap-2">
                                    <span class="text-muted small text-nowrap">
                                      Uwagi #{{ idx + 1 }}:
                                    </span>

                                    <input type="text" class="form-control form-control-sm"
                                      v-model="form.articles[idx].comments" readonly>
                                  </div>
                                </div>
                              </td>
                            </tr>

                            <!-- ROZWINIĘTE POZYCJE GRUPY -->
                            <template v-if="isArticleGroupExpanded(group.key)">
                              <tr v-for="idx in group.indexes" :key="'expanded-table-' + idx">
                                <td colspan="12">
                                  <div class="border-start border-3 ps-3 py-2">

                                    <div class="row g-2 align-items-end">

                                      <!-- Pozycja -->
                                      <div class="col-md-1">
                                        <label class="form-label small mb-1">
                                          Pozycja
                                        </label>

                                        <div class="fw-bold">
                                          #{{ idx + 1 }}
                                        </div>
                                      </div>

                                      <!-- Ilość + rezerwacja POD ilością -->
                                      <div class="col-md-2">
                                        <label class="form-label small mb-1">
                                          Ilość
                                        </label>

                                        <div class="d-flex align-items-center">
                                          <input type="number" step="0.1" min="0" class="form-control form-control-sm"
                                            v-model.number="form.articles[idx].quantity_required">

                                          <span class="ms-1 text-nowrap">
                                            {{ form.articles[idx].unit }}
                                          </span>
                                        </div>

                                        <!-- TYLKO jeśli faktycznie coś jest zarezerwowane -->
                                        <div v-if="
                                          reservations[
                                            `${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`
                                          ]?.currentlyReserved > 0
                                        " class="mt-1">
                                          <small class="text-muted">
                                            Zarezerwowane:
                                          </small>

                                          <span :class="reservations[
                                            `${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`
                                          ].reservationStatus === 'zatwierdzone'
                                            ? 'reservation-approved'
                                            : 'reservation-notapproved'
                                            ">
                                            {{
                                              reservations[
                                                `${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`
                                              ].currentlyReserved
                                            }}
                                            -
                                            {{
                                              reservations[
                                                `${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`
                                              ].reservationStatus
                                            }}
                                          </span>
                                        </div>
                                      </div>

                                      <!-- Termin -->
                                      <div class="col-md-2">
                                        <label class="form-label small mb-1">
                                          Termin
                                        </label>

                                        <input type="date" class="form-control form-control-sm"
                                          v-model="form.articles[idx].delivery_date_deadline">
                                      </div>

                                      <!-- Cena netto -->
                                      <div class="col-md-2">
                                        <label class="form-label small mb-1">
                                          Cena netto
                                        </label>

                                        <input type="number" min="0" step="0.01" class="form-control form-control-sm"
                                          v-model.number="form.articles[idx].price_netto">
										  
                                      </div>
                                      <div class="col-md-2">
                                        <label class="form-label small mb-1">
                                          Cena brutto
                                        </label>
<input
  type="number"
  min="0"
  step="0.01"
  class="form-control form-control-sm mt-1"
  :value="calculateGrossValue(form.articles[idx])"
  @change="updatePriceFromGross(form.articles[idx], $event.target.value)"
  placeholder="Cena brutto"
>
										  
                                      </div>
                                      <!-- Rabat -->
                                      <div class="col-md-1">
                                        <label class="form-label small mb-1">
                                          Rabat
                                        </label>

                                        <input type="number" class="form-control form-control-sm"
                                          v-model.number="form.articles[idx].rabate">
										  
                                      </div>

                                      <!-- VAT -->
                                      <div class="col-md-1">
                                        <label class="form-label small mb-1">
                                          VAT
                                        </label>

                                        <input type="number" class="form-control form-control-sm"
                                          v-model.number="form.articles[idx].vat">
                                      </div>
                                      <!-- Wartość netto -->
                                      <div class="col-md-2">
                                        <label class="form-label small mb-1">
                                          Wartość netto
                                        </label>

                                        <input type="number" min="0" step="0.01" class="form-control form-control-sm"
                                          :value="calculateNettoValue(form.articles[idx])" @change="updatePriceFromNetto(
                                            form.articles[idx],
                                            $event.target.value,
                                            form.articles[idx].quantity_required
                                          )">
                                      </div>
                                      <!-- Waluta -->
                                      <div class="col-md-2">
                                        <label class="form-label small mb-1">
                                          Waluta
                                        </label>

                                        <select class="form-select form-select-sm"
                                          v-model.number="form.articles[idx].currency">
                                          <option v-for="currency in currencys" :key="currency.id" :value="currency.id">
                                            {{ currency.name }}
                                          </option>
                                        </select>
                                      </div>

                                      <!-- Usuń -->
                                      <div class="col-md-1">
                                        <button type="button" class="btn btn-sm btn-outline-danger" title="Usuń artykuł"
                                          @click="removeArticle(idx)">
                                          <i class="bi bi-trash"></i>
                                        </button>
                                      </div>

                                      <!-- Uwagi -->
                                      <div class="col-12">
                                        <label class="form-label small mb-1">
                                          Uwagi do pozycji
                                        </label>

                                        <input type="text" class="form-control form-control-sm"
                                          v-model="form.articles[idx].comments">
                                      </div>

                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </template>
                          </template>

                        </template>
                      </tbody>
                    </table>
                  </div>
                </template>



                <div class="border-top pt-3 mt-3 me-5 d-flex justify-content-end">
                  <div class="fw-bold fs-5">
                    Podsumowanie netto po rabacie:
                    {{ getTotalNetto().toLocaleString('pl-PL', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }) }}
					<br>
                    Podsumowanie rabatu:
                    {{ getTotalRabat().toLocaleString('pl-PL', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }) }}

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer flex-column align-items-stretch">

            <div class="d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                <i class="bi bi-x-square me-2"></i>
                Zamknij
              </button>

              <form @submit.prevent="saveOrder">
                <button type="submit" class="btn btn-primary"
                  :disabled="form.processing || emailsOk || orderHasMultipleCurrencies || negotiationDiscountError">
                  <i class="bi bi-save me-2"></i>
                  Utwórz zamówienie
                </button>
              </form>
            </div>
            <div v-if="negotiationDiscountError" class="alert alert-danger mb-0 mt-2 text-center">
              <i class="bi bi-exclamation-triangle-fill me-2"></i>
              <strong>Nie można utworzyć zamówienia.</strong>
              Wybrany rodzaj negocjacji nie pozwala na ustawienie rabatu 0%.
            </div>
            <div v-if="orderHasMultipleCurrencies" class="alert alert-danger mb-0 mt-2 text-center">
              <i class="bi bi-exclamation-triangle-fill me-2"></i>
              <strong>Nie można utworzyć zamówienia.</strong>
              W zamówieniu występuje więcej niż jedna waluta.
              Wszystkie pozycje zamówienia muszą mieć tę samą walutę.
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal, Tooltip } from "bootstrap";
import { useForm } from "@inertiajs/vue3";
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import Index from "../OrderLists/Index.vue";
import TagSelect from "../RequiredProjectItems/TagSelect.vue";

export default {
  components: { TagSelect, Index, 'ejs-datepicker': DatePickerComponent },
  props: {
    project: Number | String,
    currencys: Object,
    team: String,
    negotiations: {
      type: Array,
      default: () => [],
    },
    order_where_list: Array,
    selectedItems: {
      type: Object,
      default: () => {
      }
    },
    context: String
  },

  beforeMount() {
    this.getSuppliersEmails();
    this.getPaymentMethods();
  },

  data() {
    return {
      isSaving: false,
	  fixedNettoAmount: null,
      isClosingConfirmed: false,
      productViewMode: 'details',
      expandedGroups: {},
      errors: {},
      isReady: false,
      currency: 0,
      emailsOk: false,
      quoteRequestNumbers: {},
      suppliersList: {},
      paymentMethods: {},
      modalObj: null,
      reservations: {},
      dueDateFormat: 'dd.MM.yyyy',
      suppliersEmails: [],
      globalRabate: 0,
      globalCurrency: null,
      form: useForm({
        order_where: 1,
		order_where_manual: '',
        dueDate: this.defaultDueDate(),
        payment_id: 1,
        negotiation: 1,
        comment: '',
        emails: [],
        articles: {}
      })
    }
  },

  watch: {
    'form.emails': {
      deep: true,
      handler(val) {
        if (!Array.isArray(val)) return

        val.forEach(e => {
          if (!e) return

          if (!Array.isArray(e.dw)) {
            e.dw = e.dw ? [e.dw] : []
          }
        })
      }
    },

    selectedItems: {
      immediate: true,
      handler(newItems) {
        this.isReady = false

        if (!newItems) return
        this.form = useForm({
          order_where: this.form.order_where || 1,
		  order_where_manual: this.form.order_where_manual || '',
          dueDate: this.defaultDueDate(),
          comment: '',
          emails: this.prepareSuppliersEmails(newItems),
          payment_id: this.form.payment_id || 1,
          negotiation: this.form.negotiation || 1,
          articles: newItems.map((article) => {
            const quoteRequest = article.quote_request ? {
              id: article.quote_request.id,
              comment: article.quote_request.comment,
              due_date: article.quote_request.due_date,
              project_id: article.quote_request.project_id,
              request_number: article.quote_request.request_number,
              team_name: article.quote_request.team_name,
            } : null
            return {

			  //project_id: article.quote_request?.project_id || article.project_id,
              //team_name: article.quote_request?.team_name || article.team_name,
			  
			  project_id: article.project_id || article.quote_request?.project_id,
			  team_name: article.team_name || article.quote_request?.team_name,
              article_id: article.article?.id,
              quote_request: quoteRequest,
              quote_request_item_id: article.quote_request_item_id || null,
              quote_request_items: article.quote_request_items || null,
              required_project_items_id: article.required_project_items_id ?? article.id ?? null,
              catalog_number: article.article?.catalog_number,
              model: article.article?.model,
              supplier: article.supplier,
              quantity_required: article.quantity_required * (article.numbering?.quantity || 1),
              delivery_date_deadline: article.delivery_date_deadline ?? this.parseDueDateToInputFormat(this.defaultDueDate()),
              producer_short_name: article.article?.producer?.name || null,
              producer_id: article.article?.producer_id || '',
              price_netto: article.article?.price_netto ?? 0,
              rabate: article.article?.rabate || 0,
              vat: article.article?.vat || 23,
              currency: article.article?.currency ?? 0,
              comments: article.comments || '',
              unit: article.article?.article_unit?.name || '',
            }

          }),
        })
        this.isReady = true
        const currencies = this.form.articles.map(a => a.currency);

        const uniqueCurrencies = [...new Set(currencies)];

        if (uniqueCurrencies.length === 1) {
          this.globalCurrency = uniqueCurrencies[0];
        } else {
          this.globalCurrency = null;
        }
        this.applyGlobalRabate()
        if (this.globalCurrency) {
          this.applyGlobalCurrency()
        }
        this.loadReservations()
        this.$nextTick(() => {
          const formatted = this.parseDueDateToInputFormat(this.form.dueDate)

          this.form.articles.forEach(article => {
            if (!article.delivery_date_deadline) {
              article.delivery_date_deadline = formatted
            }
          })
        })
      },
    },
  },
  computed: {
    negotiationDiscountError() {
      return Number(this.form.negotiation) === 3 && Number(this.getTotalRabat()) === 0
    },
    hasSupplierEmail() {
      return this.form?.emails?.some(email => email.to);
    },

    groupedArticles() {
      if (!Array.isArray(this.form?.articles)) {
        return [];
      }

      const groups = new Map();
      this.form.articles.forEach((article, index) => {
        const key = article.article_id
          ? String(article.article_id)
          : `single-${index}`;
        if (!groups.has(key)) {
          groups.set(key, {
            key,
            indexes: [],
          });
        }
        groups.get(key).indexes.push(index);
      });
      return Array.from(groups.values()).map(group => ({
        ...group,
        articles: group.indexes.map(index => this.form.articles[index]),
        totalQuantity: group.indexes.reduce((sum, index) => {
          return sum + (Number(this.form.articles[index].quantity_required) || 0);
        }, 0),
        firstArticle: this.form.articles[group.indexes[0]]
      }));
    },
    orderHasMultipleCurrencies() {
      const currencies = this.form?.articles
        ?.map(article => article.currency)
        .filter(currency => currency !== null && currency !== undefined && currency !== '');

      return new Set(currencies).size > 1;
    },

    orderCurrencies() {
      return [...new Set(
        (this.form?.articles || [])
          .map(article => article.currency)
          .filter(currency => currency !== null && currency !== undefined && currency !== '')
      )];
    }
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);

    this.$refs.modalEle.addEventListener('hide.bs.modal', async (event) => {
      if (this.isSaving) {
        this.isSaving = false;
        return;
      }

      if (this.isClosingConfirmed) {
        this.isClosingConfirmed = false;
        return;
      }

      if (this.selectedItems.length === 0) {
        return;
      }

      event.preventDefault();

      const res = await Toast.fire({
        toast: false,
        icon: 'question',
        title: 'Zamknąć okno?',
        html: 'Masz wybrane zapotrzebowania. Czy na pewno chcesz zamknąć okno i odznaczyć wybrane pozycje?',
        showDenyButton: true,
        position: 'center',
        timer: false,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie'
      });

      if (res.isConfirmed) {
        this.$emit('clear-selection');

        this.isClosingConfirmed = true;
        this.modalObj.hide();
      }
    });

    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    })
    this.suppliersEmails = this.getSuppliersEmails();
  },
  methods: {
  updateGroupPriceFromGross(group, gross) {
  const brutto = Number(gross);
  const vat = Number(group.firstArticle.vat) || 0;

  if (!Number.isFinite(brutto) || brutto < 0 || vat <= -100) {
    return;
  }

  const netto = Number(
    (brutto / (1 + vat / 100)).toFixed(2)
  );

  this.updateGroupField(group, 'price_netto', netto);
},
  applyFixedNettoAmount() {
  const target = Number(this.fixedNettoAmount);

  if (
    this.fixedNettoAmount === null ||
    this.fixedNettoAmount === '' ||
    !Number.isFinite(target) ||
    target < 0
  ) {
    return;
  }

  const baseTotal = this.form.articles.reduce((sum, article) => {
    const price = Number(article.price_netto) || 0;
    const quantity = Number(article.quantity_required) || 0;

    return sum + price * quantity;
  }, 0);

  if (baseTotal <= 0 || target > baseTotal) {
    return;
  }

  this.globalRabate = Number(
    ((1 - target / baseTotal) * 100).toFixed(2)
  );

  this.applyGlobalRabate();
},

calculateGrossValue(article) {
  const netto = Number(article.price_netto) || 0;
  const vat = Number(article.vat) || 0;

  return Number(
    (netto * (1 + vat / 100)).toFixed(2)
  );
},

updatePriceFromGross(article, gross) {
  const brutto = Number(gross);
  const vat = Number(article.vat) || 0;

  if (!Number.isFinite(brutto) || brutto < 0 || vat <= -100) {
    return;
  }

  article.price_netto = Number(
    (brutto / (1 + vat / 100)).toFixed(2)
  );
},

    updateGroupField(group, field, value) {
      group.indexes.forEach(idx => {
        if (this.form.articles[idx]) {
          this.form.articles[idx][field] = value;
        }
      });
    },

    calculateNettoValue(article, quantity = null) {
      const price = Number(article.price_netto) || 0;
      const qty = quantity !== null
        ? Number(quantity) || 0
        : Number(article.quantity_required) || 0;
      const rabate = Number(article.rabate) || 0;

      return Number(
        (price * qty * (1 - rabate / 100)).toFixed(2)
      );
    },

    updatePriceFromNetto(article, totalNetto, quantity) {
      const netto = Number(totalNetto) || 0;
      const qty = Number(quantity) || 0;
      const rabate = Number(article.rabate) || 0;

      if (qty <= 0 || rabate >= 100) {
        return;
      }

      article.price_netto = Number(
        (netto / qty / (1 - rabate / 100)).toFixed(2)
      );
    },


    toggleArticleGroup(groupKey) {
      this.expandedGroups = {
        ...this.expandedGroups,
        [groupKey]: !this.expandedGroups[groupKey]
      };
    },

    isArticleGroupExpanded(groupKey) {
      return !!this.expandedGroups[groupKey];
    },

    getArticleGroup(groupKey) {
      return this.groupedArticles.find(group => group.key === groupKey);
    },

    getArticleGroupTotalQuantity(group) {
      return group.indexes.reduce((total, index) => {
        return total + (Number(this.form.articles[index]?.quantity_required) || 0);
      }, 0);
    },
    mergeComments(items) {
      const comments = items
        .map(item => item.comments)
        .filter(comment => comment && comment.trim())
        .map(comment => comment.trim());

      return [...new Set(comments)].join(' | ');
    },

    getTotalNetto() {
      if (!Array.isArray(this.form.articles)) {
        return 0;
      }

      return this.form.articles.reduce((sum, article) => {
        const price = Number(article.price_netto) || 0;
        const qty = Number(article.quantity_required) || 0;
        const rabate = Number(article.rabate) || 0;
        return sum + (price * qty * (1 - rabate / 100));
      }, 0);
    },
    getTotalRabat() {
      return this.form.articles.reduce((sum, article) => {
        const price = Number(article.price_netto) || 0;
        const qty = Number(article.quantity_required) || 0;
        const rabate = Number(article.rabate) || 0;
        const rabat = price * qty * (rabate / 100);
        return sum + rabat;
      }, 0);
    },

    setEmailCustomer(key, item) {
      this.form.emails[key].customer_id = item.customer_id;
    },
    parseDueDateToInputFormat(dateStr) {
      if (!dateStr) return null
      const [day, month, year] = dateStr.split('.')
      return `${year}-${month}-${day}`
    },
    normalizeEmail(value) {
      if (!value) return null
      if (typeof value === 'object') {
        value = value.value || value.email || value.label
      }
      if (typeof value !== 'string') return null
      return value.trim().toLowerCase()
    },

    safeDw(value) {
      if (!Array.isArray(value)) return []
      return value
        .map(v => {
          if (!v) return null
          if (typeof v === 'object') return v.value || v.email || v.label
          return v
        })
        .filter(v => typeof v === 'string' && v.includes('@'))
    },
    addManualDwEmail(key, event) {
      const raw = event.target.value.trim()
      const value = this.normalizeEmail(raw)
      if (!value || !value.includes('@')) return

      if (!Array.isArray(this.form.emails[key].dw)) {
        this.form.emails[key].dw = []
      }
      const cleanList = this.form.emails[key].dw
        .map(v => this.normalizeEmail(v))
        .filter(Boolean)
      if (!cleanList.includes(value)) {
        cleanList.push(value)
      }
      this.form.emails[key].dw = cleanList
      event.target.value = ''
    },

    removeDwEmail(key, index) {
      if (!Array.isArray(this.form.emails[key].dw)) {
        this.form.emails[key].dw = []
        return
      }
      this.form.emails[key].dw = this.form.emails[key].dw.filter((_, i) => i !== index)
    },

    defaultDueDate() {
      const today = new Date();
      const nextWeek = new Date(today);
      nextWeek.setDate(today.getDate() + 7);
      const year = nextWeek.getFullYear();
      const month = String(nextWeek.getMonth() + 1).padStart(2, '0');
      const day = String(nextWeek.getDate()).padStart(2, '0');
      return `${day}.${month}.${year}`;
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    changeDeliveryDate(date) {
      this.form.dueDate = date.value;
      const formatted = this.formatDate(date.value);
      this.form.articles.forEach(article => {
        article.delivery_date_deadline = formatted;
      });
    },

    applyGlobalRabate() {
      this.form.articles.forEach(article => {
        article.rabate = this.globalRabate;
      });
    },

    applyGlobalCurrency() {
      this.form.articles.forEach(article => {
        article.currency = Number(this.globalCurrency);
      });
    },

    prepareSuppliersEmails(items) {
      const suppliersEmails = []
      const seenEmails = new Set()

      items.forEach((item) => {
        const email = item.supplier?.customers_data?.email

        if (
          item.supplier &&
          Object.keys(item.supplier).length > 0 &&
          email &&
          !seenEmails.has(email)
        ) {
          seenEmails.add(email)
          suppliersEmails.push({
            to: email,
            customer_id: supplierId,
            dw: []
          })
        }
      })
      if (suppliersEmails.length === 0) {
        suppliersEmails.push({
          to: '',
          dw: []
        })
      }

      return suppliersEmails
    },

    changeComment(event) {
      this.form.comment = event;
    },

    async getSuppliersEmails() {
      const suppliers = await axios.get(route('suppliers.get-all-suppliers'));
      this.suppliersList = suppliers.data;
    },

    async getPaymentMethods() {
      const methods = await axios.get(route('paymentMethods.getAll'));
      this.paymentMethods = methods.data;
    },
    saveOrder() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      this.form.emails = this.form.emails.map(e => {
        const normalize = (v) => {
          if (!v) return null
          if (typeof v === 'object') v = v.value || v.email || v.label
          if (typeof v !== 'string') return null
          return v.trim().toLowerCase()
        }
        const to = normalize(e.to)
        const dw = (Array.isArray(e.dw) ? e.dw : [e.dw])
          .map(normalize)
          .filter(v => emailRegex.test(v))
        return {
          ...e,
          to,
          dw
        }
      })

      this.form.post(route('orderLists.store'), {
        onSuccess: () => {
          this.$emit('added-success', 'Zamówienie zostało utworzone.')
          this.isSaving = true;
          this.$emit('clear-selection');
          this.hide();
        },
        onError: (errors) => {
          console.log('errors:', errors)
          this.errors = errors
          let errorMessages = Object.values(errors).flat().join(', ')
          this.$emit('added-error', 'Błąd podczas tworzenia zamówienia: ' + errorMessages)
        }
      })
    },

    async loadReservations() {
      for (const article of this.form.articles) {
        try {
          const response = await axios.get(route('warehouse.check-article-reservation', {
            article: article.article_id,
            required_project_item_id: article.required_project_item_id,
            reserving: 0
          }));

          const key = `${article.article_id}-${article.required_project_item_id}`;
          this.reservations[key] = response.data;
        } catch (error) {
          console.error(error);
        }
      }
    },

    removeArticle(idx) {
      this.form.articles.splice(idx, 1);
    },

    hasError(field) {
      const error = this.errors && this.errors[field];
      return error;
    },

    getErrorMessage(field) {
      if (!this.errors[field]) {
        return '';
      }
      if (/^Pole .*? jest wymagane\.$/.test(this.errors[field])) {
        return 'To pole jest wymagane.';
      }
      return 'To pole ma niepoprawną wartość';
    },

    show() {
      if (this.modalObj) {
        this.globalRabate = 0;
        this.globalCurrency = 0;
        this.applyGlobalRabate();
        this.applyGlobalCurrency();
        this.modalObj.show();
      }
    },
    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
  }
}
</script>


<style scoped>
.widthFirstTd {
  width: 150px;
}

.order-list-table:not(:first-child) {
  border-top: 2px solid #222;
}

.reservation-approved {
  color: #1abc9c !important;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
}

.reservation-notapproved {
  color: #e7515a !important;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
}

.table.order-list-table {
  font-size: 13px;
  margin-bottom: 0.75rem;
}

.table.order-list-table td,
.table.order-list-table th {
  padding: 4px 6px !important;
  vertical-align: middle !important;
}

.table.order-list-table input.form-control-sm,
.table.order-list-table select.form-select-sm {
  padding: 2px 6px;
  height: 28px;
  font-size: 13px;
}

.table.order-list-table .widthFirstTd {
  width: 140px;
  font-weight: 500;
  color: #444;
}

.order-list-table:not(:first-child) {
  border-top: 1px solid #bbb;
  margin-top: 6px;
  padding-top: 4px;
}

h6,
.font-weight-bolder {
  font-size: 13px;
}

.reservation-approved,
.reservation-notapproved {
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 12px;
}

.btn.btn-sm.btn-outline-danger {
  padding: 4px 6px;
  font-size: 13px;
  line-height: 1;
}

.order-products-table th {
  white-space: nowrap;
  font-size: 0.85rem;
}

.order-products-table td {
  font-size: 0.85rem;
  vertical-align: middle;
}

.order-products-table input,
.order-products-table select {
  min-width: 70px;
}

.order-products-table .table-light td {
  background-color: #f8f9fa;
}
</style>